module.exports = __webpack_public_path__ + "media/images/icons/plus-3d1f357f6132b5c1eb41211d63f463fb.svg";